<template>
	<div
		v-if="errorStore.show && errorStore.message"
		:error="errorStore.message"
		class="general-error"
		:class="errorStore.type"
		:style="[$_appViewPosition_positionBottom]"
		v-html="errorStore.message"
	/>
</template>

<script type="text/javascript">

import { errorStore } from '../../store/errorStore'

export default {

	data () {
		return {
			errorStore: errorStore.state
		}
	},

	mounted () {
		errorStore.removeMessage()	
	}
}

</script>

<style scoped>

.general-error {
	position: fixed;
	bottom: 0px;
	left: 50%;
	transform: translateX(-50%) translateY(-25px);
	background-color: var(--quomi-red);
	color: white;
	border-radius: 4px;
	padding: 5px 10px;
	z-index: 6;
	text-align: center;
}

.general-error.info {
	background-color: var(--quomi-blue);
}

@media (max-width: 1024px){
	.general-error {
		transform: translateX(-50%) translateY(-14px);
		font-size: 13px;
	}
}
</style>
